import { render, staticRenderFns } from "./BaseEmailAddresses.vue?vue&type=template&id=1deb0656&"
import script from "./BaseEmailAddresses.vue?vue&type=script&lang=js&"
export * from "./BaseEmailAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports